import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InteractionType, KeyValues5, LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-select-business',
  templateUrl: './select-business.component.html',
  styleUrls: ['./select-business.component.scss']
})
export class SelectBusinessComponent implements OnInit {
  items: KeyValues5[]; interactionType: InteractionType; isIncludeInactive = false;
  constructor(public localService: LocalService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.onLoad();
  }

  onLoad() {
    this.items = this.isIncludeInactive ? this.localService.loggedMember.businesses.filter(x => x.v5 == 'BU' && x.v6 == '0') : this.localService.loggedMember.businesses.filter(x => x.v2 == '1' && x.v5 == 'BU' && x.v6 == '0');
    if (this.interactionType == InteractionType.User) {
      let user = this.localService.loggedMember.loggedMember.content;
      this.items.unshift({ key: "0", v3: user.v1, v4: user.v5 } as KeyValues5);
    }
  }

  onSelect(id) {
    this.activeModal.close({ event: TriggeredEvent.Ok, businessId: id });
  }
}
